import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "left-section" }
const _hoisted_2 = { class: "d-flex flex-column align-start ga-2" }
const _hoisted_3 = { class: "text-body-2" }
const _hoisted_4 = { class: "right-section d-flex flex-column justify-space-between" }
const _hoisted_5 = { class: "created-at text-caption text-medium-emphasis text-right mb-2" }
const _hoisted_6 = { class: "text-h5 font-weight-medium mb-3 text-center text-md-start" }
const _hoisted_7 = { class: "text-body-2 mb-6 text-center text-md-start" }
const _hoisted_8 = { class: "d-flex justify-center justify-md-start" }


import { ArticleCardProps, Platform } from './ArticleCard.model';

import liquipediaIcon from '@/assets/imgs/liquipedia.png';
import youtubeIcon from '@/assets/imgs/youtube.png';
import tiktokIcon from '@/assets/imgs/tiktok.png';
import soopIcon from '@/assets/imgs/soop.png';
import twitchIcon from '@/assets/imgs/twitch.png';
import instagramIcon from '@/assets/imgs/instagram.webp';
import twitterIcon from '@/assets/imgs/twitter.png';
import redditIcon from '@/assets/imgs/reddit.png';
import w3championsIcon from '@/assets/imgs/w3c.png';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleCard',
  props: {
    title: {},
    shortDescription: {},
    slug: {},
    image: {},
    links: {},
    createdAt: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

const goToArticle = () => {
  router.push({ name: 'news-article', params: { slug: props.slug } });
};

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "blog-card d-flex flex-column flex-md-row pa-4 rounded-xl elevation-3 ga-4 align-start justify-space-between",
    "max-width": "950"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_img, {
          src: __props.image,
          class: "rounded-lg mb-4",
          "aspect-ratio": "5/3",
          width: "100%",
          cover: ""
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (item, i) => {
            return (_openBlock(), _createBlock(_component_v_btn, {
              key: i,
              href: item.link,
              target: "_blank",
              variant: "text",
              density: "comfortable",
              class: "pa-0 text-none d-flex align-center justify-start w-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  size: "26",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [
                    (item.platform === _unref(Platform).YOUTUBE)
                      ? (_openBlock(), _createBlock(_component_v_img, {
                          key: 0,
                          src: _unref(youtubeIcon)
                        }, null, 8, ["src"]))
                      : (item.platform === _unref(Platform).TWITCH)
                        ? (_openBlock(), _createBlock(_component_v_img, {
                            key: 1,
                            src: _unref(twitchIcon)
                          }, null, 8, ["src"]))
                        : (item.platform === _unref(Platform).TIKTOK)
                          ? (_openBlock(), _createBlock(_component_v_img, {
                              key: 2,
                              src: _unref(tiktokIcon)
                            }, null, 8, ["src"]))
                          : (item.platform === _unref(Platform).INSTAGRAM)
                            ? (_openBlock(), _createBlock(_component_v_img, {
                                key: 3,
                                src: _unref(instagramIcon)
                              }, null, 8, ["src"]))
                            : (item.platform === _unref(Platform).TWITTER)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 4,
                                  src: _unref(twitterIcon)
                                }, null, 8, ["src"]))
                              : (item.platform === _unref(Platform).REDDIT)
                                ? (_openBlock(), _createBlock(_component_v_img, {
                                    key: 5,
                                    src: _unref(redditIcon)
                                  }, null, 8, ["src"]))
                                : (item.platform === _unref(Platform).LIQUIPEDIA)
                                  ? (_openBlock(), _createBlock(_component_v_img, {
                                      key: 6,
                                      src: _unref(liquipediaIcon)
                                    }, null, 8, ["src"]))
                                  : (item.platform === _unref(Platform).SOOP)
                                    ? (_openBlock(), _createBlock(_component_v_img, {
                                        key: 7,
                                        src: _unref(soopIcon)
                                      }, null, 8, ["src"]))
                                    : (item.platform === _unref(Platform).W3CHAMPIONS)
                                      ? (_openBlock(), _createBlock(_component_v_img, {
                                          key: 8,
                                          src: _unref(w3championsIcon)
                                        }, null, 8, ["src"]))
                                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.description), 1)
              ]),
              _: 2
            }, 1032, ["href"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(new Date(__props.createdAt)
              .toLocaleString(undefined, {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })
              .replace(',', '')), 1),
          _createElementVNode("h2", _hoisted_6, _toDisplayString(__props.title), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.shortDescription), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            class: "mt-2",
            onClick: goToArticle
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Read More", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})